import request from '@/utils/httpRequest'

//修改头像
export function updateAvatar(obj) {
  return request({
    url: '/api/bsd/user/updateAvatar',
    method: 'post',
    data: obj,
  })
}

//修改密码
export function updatePassword(obj) {
  return request({
    url: '/api/bsd/user/updatePassword',
    method: 'post',
    data: obj,
  })
}

//修改昵称
export function updateNickname(obj) {
  return request({
    url: '/api/bsd/user/updateNickName',
    method: 'post',
    data: obj,
  })
}

//用户信息
export function getUserInfo(obj) {
  return request({
    url: '/api/getUser',
    method: 'get',
    params: obj,
  })
}

//搜索经销商、PPN
export function searchList(obj) {
  return request({
    url: '/api/bsd/user/ppnList',
    method: 'post',
    data: obj,
  })
}

//个人中心-学员的排名
export function getUserSort(obj) {
  return request({
    url: '/api/bsd/user/getUserSortByPpn',
    method: 'post',
    data: obj,
  })
}

//根据PPN号获取账号信息
export function getUserByPpn(obj) {
  return request({
    url: '/api/bsd/user/getUserByPpn',
    method: 'post',
    data: obj,
  })
}

//获取历年学分
export function getHistory(obj) {
  return request({
    url: '/api/bsd/user/getUserHistory',
    method: 'post',
    data: obj,
  })
}

//充电保学分
export function getCdb(obj) {
  return request({
    url: '/api/bsd/user/getUserCdb',
    method: 'post',
    data: obj,
  })
}